<template>
  <div class="resultCreateDebt_warpper">
    <nav-bar titleText="提交结果" titleWeight="bold" @goBack="goBack"></nav-bar>
    <results-page
      @handleOperationClick="handleOperationClick"
      @handleReturnClick="handleReturnClick"
      operationDisplab
      operationText="查看订单"
      returnDisplab
      returnText="返回"
      :imgSrc="imgSrc"
      instructions="已成功提交打款凭证借条"
    ></results-page>
  </div>
</template>
<script>
import navBar from "../components/navBar";
import resultsPage from "../components/resultsPage";
export default {
  name: "creditor_resultIOU",
  data() {
    return {
     imgSrc:  require("../../../assets/debtor/resultOk.png")
    };
  },
  created() {},
  components: {
    navBar,
    resultsPage,
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    handleOperationClick() { // this.$route.query.id
      this.$router.push({
        path: '/debtor/detail',
        query: {
          order_id: this.$route.query.id
        }
      })
    },
    // 返回事件，返回债权人首页
    handleReturnClick() {
      // this.$router.push('/creditor/debtorView')
      this.$router.go(-1)
    }
  }
};
</script>
<style lang="less">
.resultCreateDebt_warpper {
  padding-top: 88px;
  box-sizing: border-box;
  background-color: #f5f6f7;
  min-height: 100%;
  font-size: 16px;
  color: #333;
}
</style>
